import React from 'react';
import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { BottomNav } from './BottomNav';
import { DesktopSidebar } from './DesktopSidebar';
import { Toast } from '../feedback/Toast';
import { NotificationPanel } from '../feedback/NotificationPanel';

interface AppShellProps { title?: string; showBack?: boolean; actions?: React.ReactNode; noNav?: boolean; }

export const AppShell: React.FC<AppShellProps> = ({ title, showBack, actions, noNav }) => (
  <div className="app-frame">
    <a className="skip-link" href="#main-content">Skip to content</a>
    <div className="app-layout">
      {!noNav && <DesktopSidebar />}
      <div className="app-content">
        <TopBar title={title} showBack={showBack} actions={actions} />
        <main id="main-content" className="app-main" tabIndex={-1}><Outlet /></main>
      </div>
    </div>
    {!noNav && <BottomNav />}
    <Toast />
    <NotificationPanel />
  </div>
);
